import type { FaireProductEntity } from "../../entity_types/product";

export const p_cmub6f3lii: FaireProductEntity = {
  token: "p_cmub6f3lii",
  type: "product",
  name: "Coffee Makes Me Poop Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d51d34e1a01944fddf023beb4ffe41d976ac2636601124aeca50ec7799967798.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/027eb5e052d03fb051fca8fc7b4da7568e8c6afe92d087669f63cc86757d6f3b.jpeg",
    "https://cdn.faire.com/fastly/c146651e47401bd87f50c0de80956e742f2b6e46fc5339d68f48eb3494715992.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5013d3daf15d6449bdf380e90d4390a43a8ab4a4216cf692f614c9caa86ff3bd.jpeg"
  ],
  priceDollars: 6.75,
  description: "Nothing quite like sipping on a fresh cup 'o joe. Wakes you up, gets you movin' and groovin', until your tummy says 'woah!'. Everyone loves a solid morning routine, no matter where you start your day... you can guarantee you'll always end up conducting... essential business...\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:55.810Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
